<template>
  <div class="d-flex flex-column sign-up">
    <app-header />
    <b-container class="flex-grow-1">
      <b-row align-h="center">
        <b-col lg="6" xl="5">
          <template v-if="submitted">
            <h3 class="text-center m-5">Thank you</h3>
          </template>
          <b-card v-else-if="!verifying" class="mt-4 mb-4">
            <h5 v-if="verifyData.team" class="text-center mb-5">
              Invitation to <strong>{{verifyData.team.company.name}}/{{verifyData.team.name}}</strong> team
            </h5>
            <invitation-link-form
              :submitting="submitting"
              :state="state"
              @submit="onSendInvitation"
            />
          </b-card>
          <div v-else class="text-center p-5">
            <b-spinner variant="primary" label="Loading..." />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HeaderAlt as AppHeader } from '@/components/Header'
import InvitationLinkForm from '@/components/forms/InvitationLinkForm.vue'

export default {
  name: 'InvitationLink',

  computed: {
    verifyKey() {
      return this.$route.params.key
    },

    companySlug() {
      return this.$route.params.companySlug
    }
  },

  data() {
    return {
      verifying: true,
      submitting: false,
      submitted: false,
      state: {},
      verifyData: {}
    }
  },

  async mounted() {
    this.verifying = true
    try {
      this.verifyData = await this.$store.dispatch('validateInvitationLink',
        { companySlug: this.companySlug, key: this.verifyKey })
    } catch (error) {
      this.state = error
    } finally {
      this.verifying = false
    }
  },

  methods: {
    onSendInvitation({ email }) {
      this.submitting = true
      this.$store.dispatch('inviteUserByInvitationLink',
        { companySlug: this.companySlug, key: this.verifyKey, email })
        .then(() => (this.submitted = true))
        .finally(() => (this.submitting = false))
    }
  },

  components: {
    InvitationLinkForm,
    AppHeader
  }
}
</script>
